import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import AssetSupportIcon from './icons/AssetSupportIcon';

// Sub-lg-only "Request Support" kebab entry, always the menu's FIRST item
// (QA round 3, 2026-08-19 — Steffon call, matching the mobile design's
// kebab). Desktop keeps the tab-row text button, so this mirrors it
// `lg:hidden` the same way PhotosMenuItems' Download/Upload mirror their
// control-row icons. Deliberately never disabled: on Zillow the rest of the
// kebab renders inert, but support must stay reachable on every tab.
// Consumers with more items add their own `lg:hidden` separator after it;
// Trash renders it alone, so no separator lives here.
const RequestSupportMenuItem = ({
  onOpenSupportRequest
}: {
  onOpenSupportRequest: () => void;
}) => (
  <DropdownMenuItem className="lg:hidden" onSelect={onOpenSupportRequest}>
    <AssetSupportIcon className="w-4 h-4" />
    Request Support
  </DropdownMenuItem>
);

export default RequestSupportMenuItem;
